import React, { createContext, useContext } from "react";
import { useQuery } from "seed/gql";

const CollectionsContext = createContext(undefined);

const useCollections = ({ checkContext = true } = {}) => {
  const context = useContext(CollectionsContext);
  if (!context) {
    if (checkContext)
      throw new Error("useCollections must be used within a CollectionsProvider");
    return { collections: [], reqCollections: { loaded: true } };
  }
  return context;
};

const CollectionsProvider = ({
  flowId,
  children,
}) => {
  const reqCollections = useQuery(`{
    collections {
      name
      schema
      uiSettings
    }
  }`, `(flow_id=${flowId} AND is_active=true)`)

  const collections = reqCollections.data.collections;


  return (
    <CollectionsContext.Provider value={{ collections, reqCollections }}>
      {children}
    </CollectionsContext.Provider>
  );
};


export { CollectionsProvider, useCollections };